document.addEventListener('DOMContentLoaded', () => {
    const banner = document.querySelector('.announcement-bar-section'); // or .slideshow-banner
    console.log(banner)
    if (banner) {
        document.documentElement.style.setProperty('--banner-height', `${banner.offsetHeight}px`);
    }
    
    window.addEventListener('resize', () => {
        if (banner) {
        document.documentElement.style.setProperty('--banner-height', `${banner.offsetHeight}px`);
        }
    });
});